import React from "react";
import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Paper,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { useStyles } from "../../campaignModalStyles";
import { i18n } from "../../../../translate/i18n";
import { getProviderLabel } from "../../../../constants/aiProviderCatalog";

const ResponderTabContent = ({
  values,
  setFieldValue,
  touched,
  errors,
  campaignEditable,
  promptsList,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Grid xs={12} item>
      <Paper style={{ padding: 20, backgroundColor: theme.palette.background.paper, marginBottom: 16 }}>
        <Typography variant="h6" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: 12, display: "flex", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
          <span role="img" aria-label={i18n.t("campaigns.dialog.ai.ariaAiEnvironment")}>
            ✨
          </span>
          <span>{i18n.t("campaigns.dialog.ai.responderTitle")}</span>
        </Typography>
        <Box mb={2} px={1.5} py={1} style={{ borderRadius: 8, backgroundColor: "rgba(33,150,243,0.09)", display: "flex", alignItems: "flex-start", gap: 10 }}>
          <span role="img" aria-hidden style={{ fontSize: "1.2rem", lineHeight: 1.25, flexShrink: 0 }}>
            🤖
          </span>
          <Typography variant="body2" component="span" style={{ flex: 1 }}>
            {i18n.t("campaigns.dialog.ai.responderBanner")}
          </Typography>
        </Box>
        <FormControl
          variant="outlined"
          margin="dense"
          fullWidth
          className={`${classes.formControl} ${classes.selectField}`}
          error={touched.replyPromptId && Boolean(errors.replyPromptId)}
          disabled={!campaignEditable}
        >
          <InputLabel id="campaign-replyPromptId-label" style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span role="img" aria-hidden>🤖</span>
            {i18n.t("campaigns.dialog.ai.replyPromptAgent")}
          </InputLabel>
          <Select
            labelId="campaign-replyPromptId-label"
            id="campaign-replyPromptId-select"
            value={
              values.replyPromptId === null || values.replyPromptId === undefined
                ? ""
                : values.replyPromptId
            }
            onChange={(e) => {
              const v = e.target.value;
              setFieldValue("replyPromptId", v === "" ? "" : Number(v));
            }}
            label={i18n.t("campaigns.dialog.ai.replyPromptAgent")}
          >
            <MenuItem value="">
              <em>{i18n.t("campaigns.dialog.ai.promptPlaceholderReply")}</em>
            </MenuItem>
            {(promptsList || []).map((p) => (
              <MenuItem key={`reply-${p.id}`} value={p.id}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                  <span style={{ fontWeight: 600 }}>{p.name}</span>
                  <Typography variant="caption" color="textSecondary">
                    {getProviderLabel(p.provider)}
                  </Typography>
                </div>
              </MenuItem>
            ))}
          </Select>
          {touched.replyPromptId && errors.replyPromptId ? (
            <Typography variant="caption" color="error" style={{ marginLeft: 14, marginTop: 4 }}>
              {errors.replyPromptId}
            </Typography>
          ) : null}
        </FormControl>
      </Paper>
    </Grid>
  );
};

export default ResponderTabContent;
